import { render, staticRenderFns } from "./PedidosRealizados.vue?vue&type=template&id=a798c1be"
import script from "../controllers/PedidosRealizados.ts?vue&type=script&lang=ts&external"
export * from "../controllers/PedidosRealizados.ts?vue&type=script&lang=ts&external"
import style0 from "./PedidosRealizados.vue?vue&type=style&index=0&id=a798c1be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports